<template>
  <popover
    v-model="showPopover"
    v-click-outside="{binding: togglePopover, focus: '.code-container'}"
    :class="'clickable m-l-5 changelog-json-preview-btn changelog-json-popover ' + wide ? 'changelog-json-popover--document' : ''"
    placement="left"
    trigger="manual"
  >
    <a
      class="clickable m-l-5 changelog-json-preview-btn"
      @click="togglePopover"
    >
      <i class="fa fa-file-code-o m-r-5" />
    </a>
    <template slot="popover">
      <CodeDisplay
        :code="diffJson"
        :success-translation="'Copied object'"
        :pre-class="'m-b-0'"
      >
        <div
          class="changelog-json-preview small"
          v-text="diffJson"
        />
      </CodeDisplay>
    </template>
  </popover>
</template>

<script>
import CodeDisplay from '@/core/components/CodeContainer';

export default {
  name: 'CodeContainer',
  components: {
    CodeDisplay
  },
  props:{
    diff: {
      type: Object,
      default: function() {return {};}
    },
    wide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {   
      popPosition: 'auto ' + (this.wide ? 'right' : 'left'),
      showPopover: false
    };
  },
  computed: {
    diffJson() {
      return JSON.stringify(this.diff, null, 2);
    }
  },
  methods: {     
    togglePopover() {
      this.showPopover = !this.showPopover;
    }
  }
};
</script>

<style scoped>
.changelogs.empty-changelog {
  min-height: 0;
}
</style>